<template>
<section class="content close-date-picker reports city_collection_reports_pop report_generation_progress_main" style="position: relative">
    <div class="box-body">
        <div :class="addButtonClass" class="general_reports_btn">
            <button type="button" class="btn gradientbt filter" data-toggle="modal" data-target="#filtertoogle">
                Apply Filter
                    <span :class="{'counter_filter' : count }">{{ count }}</span>
            </button>
            <button class="btn gradientbt" @click="refreshReportList">
                Refresh
            </button>
            <button class="btn gradientbt ml-5" @click="gotoReportGeneration">
                Generate Reports
            </button>
        </div>
        <v-server-table ref="wardReportTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
            <template slot="beforeBody">
                <tr v-if="loading" class="VueTables__no-results">
                    <td class="text-center" colspan="9">
                        <pulse-loader></pulse-loader>
                    </td>
                </tr>
            </template>
            <template slot="action" slot-scope="props">
                <div class="c-pointer report_generation_progress">
                    <a v-if="props.row.fileUrl == ''" disabled>Report Generation In Progress.</a>
                    <a class="fa fa-download" role="button" v-if="props.row.fileUrl != ''" v-bind:href="props.row.fileUrl" target="_blank"></a>
                    <!-- <a v-bind:href="props.row.fileUrl" target="_blank">Download</a> -->
                </div>
            </template>
        </v-server-table>
    </div>
    <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
            <div class="modal-content">
                <div class="modal-header">
                    <h2>Filters</h2>
                    <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter">
                        Clear All
                    </button>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="main_select_wrp">
                        <div class="flex selectwca_wrp " v-if="this.adminCheck == 'superAdmin'">
                            <!-- <div class="multiselected">
                                <label>City</label>
                                <multiselect track-by="id" v-model="clearFilters.city.value" label="name" placeholder="Select City" :options="cityList" name="city" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCityFilter" @remove="onRemoveCityFilter"></multiselect>
                            </div> -->
                            <div class="multiselected">      
                                <label>Zone</label>                       
                                <multiselect track-by="wardId" v-model="clearFilters.wasteCollectionArea.value" label="wardName" placeholder="Select Zone" :options="areasList" :key="areasList.length" multiple name="wasteArea" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedFilter" @remove="onRemoveFilter"></multiselect>
                   
                            </div>

                        </div>
                        <div class="flex selectwca_wrp main_select_wrp_houses" v-if="this.adminCheck !== 'superAdmin'">
                            <div class="multiselected">
                                <label>Zone</label>
                                <multiselect track-by="wardId" v-model="clearFilters.wasteCollectionArea.value" label="wardName" placeholder="Select Zone" :options="areasList" multiple name="wasteArea" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedFilter" @remove="onRemoveFilter"></multiselect>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="isGenerateReport" class="">
        <div v-if="isGenerateReport" class="">
            <div class="">
                <div class="">
                    <div id="details" class="overlay waste_type_pop">
                        <div class="overlay_inner">
                            <div class="row form-modal">
                                <vue-form :state="formstate">
                                    <h4 class="text-center">Generate Reports</h4>
                                    <div v-if="reportLoading" class="content content-centered">
                                        <pulse-loader></pulse-loader>
                                        <p>Please wait, report generation is in progress.</p>
                                    </div>
                                    <div v-if="!reportLoading" class="col-sm-12 scroll_pop" style="padding-top: 15px">
                                        <div v-if="adminCheck == 'superAdmin'" class="col-sm-12">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                                <label>City</label>
                                                <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="wardReport.cityId" v-on:change="onCheckedCity($event.target.value)">
                                                    <option value="" disabled>Select City Name</option>
                                                    <option v-for="cityId in citys" :value="cityId.id">
                                                        {{ cityId.name }}
                                                    </option>
                                                </select>
                                                <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-12">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wardId)">
                                                <label>Zone</label>
                                                <select required name="wardId" class="form-control" v-on:change="onCheckedWard($event.target.value)" v-model="wardReport.wardId">
                                                    <option value="" disabled>Select Zone</option>
                                                    <option v-for="wards in areas" :value="wards.wardId">
                                                        {{ wards.wardName }}
                                                    </option>
                                                </select>
                                                <field-messages name="wardId" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is a required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-12">
                                            <validate auto-label class="required-field" :class="fieldClassName(formstate.date)" style="min-height: 127px">
                                                <label>Date</label>
                                                <date-picker id="date" required v-model="wardReport.date" lang="en" name="date" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" :not-after="disabledAfter"></date-picker>
                                                <field-messages name="date" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is a required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>
                                </vue-form>
                                <div class="form-actions">
                                    <button class="mr-5 btn btn-default" type="button" @click="onModalClose">
                                        Cancel
                                    </button>
                                    <button class="mr-2 btn gradientbt" type="submit" @click="generateReport" :disabled="!(formstate.$dirty && formstate.$valid)">
                                        Generate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import {
    USER_ROLES
} from "../../../config";
import {
    Event
} from "vue-tables-2";
import moment from "moment-timezone";
import {
    mapState
} from "vuex";
import {
    eventBus,
    formService,
    surveysService,
    reportsService
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import {
    fa
} from "faker/lib/locales";
import DatePicker from "vue2-datepicker";
export default {
    name: "wardReports",
    data() {
        return {
            checkedAreas:[],
            areasList:[],
            clearFilters: {
                city: "",
                wasteCollectionArea: "",
                
            },
            count: null,
            cityFilterCount: 0,
            zoneFilterCount: 0,
            cityList: [],
            disabledAfter: null,
            show: false,
            showw: false,
            page: null,
            limit: null,
            loading: null,
            wardReportTable: null,
            parameters: {},
            noResult: true,
            reportLoading: false,
            endLocForDateFilter: "",
            isGenerateReport: false,
            adminCheck: "",
            formstate: {},
            wardReport: {},
            wardList: [],
            citys: [],
            areas: [],
            isCityDisable: false,
            disabledAfter: new Date(),
            checkedWardValue: null,
            columns: ["wardName", "startDate", "createdAt", "createdBy", "action"],
            options: {
                highlightMatches: true,
                sortable: [],
                headings: {
                    cityName: "City",
                    wardName: "Zone",
                    startDate: "Start Date",
                    createdAt: "Generated On",
                    createdBy: "Generated By",
                    action: "Action",
                },
                templates: {
                    scheduleTime(row, query) {
                        return dateFormatter(query.scheduleTime);
                    },
                },
                perPage: 10,
                sortable: [
                    "cityName",
                    "wardName",
                    "startDate",
                    "createdAt",
                    "createdBy",
                ],

                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    if (request.orderBy) {
                        if(request.orderBy == "cityName"){
                            this.parameters.sortBy = "cityId.cityName";
                        } else{
                            this.parameters.sortBy = request.orderBy;
                        }
                    }
                    if (request.ascending == 1) {
                        this.parameters.sortOrder = "asc";
                    } else {
                        this.parameters.sortOrder = "dsc";
                    }
                    if (request.query.status) {
                        this.parameters.status = request.query.status;
                    }
                    if (request.query) {
                        this.parameters.searchString = request.query;
                    } else {
                        this.parameters.searchString = '';
                    }          
                    if(this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }         
                    return reportsService
                        .getReportList(this.parameters)
                        .catch((error) => {
                            console.error("report.requestFunction-error:", error);
                            this.$snotify.error("Get List", "Error!");
                        });
                },
                responseAdapter: (response) => {
                    this.loading = false;
                    let dataResp = [];
                    response.data.response.forEach((element) => {
                        let finalData = element;
                        finalData["cityName"] = element.cityId.cityName;
                        finalData["wardName"] = element.wardName ? element.wardName : "--";
                        finalData["startDate"] = element.startDate ?
                            moment(String(element.startDate)).format("DD-MM-YYYY") :
                            "--";
                        finalData["createdAt"] = element.createdAt ?
                            dateFormatter(element.createdAt) :
                            "--";
                        dataResp.push(finalData);
                    });
                    return {
                        data: dataResp,
                        count: response.data.totalCount,
                    };
                },
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.wardReportTable) {
                return this.wardReportTable.count > this.wardReportTable.limit ||
                    this.wardReportTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        clearFilter() {
            this.count = null;
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.clearFilters = {
                wasteCollectionArea: "",
              };
            this.checkedAreas = [];           
            this.parameters.zone = [];         
            if(this.$store.state.auth.user.role.key === "superAdmin"){
                this.areasList = [];
            }
            
            this.$refs.wardReportTable.refresh();
        },
        onCheckedCityFilter(option) { 
            // if(this.cityFilterCount === 1){
            //     this.count = 1;
            //     this.zoneFilterCount = 0;
            // }
            // if(this.cityFilterCount === 0){
            //     this.count += 1;
            //     this.cityFilterCount = 1;
            // }
            this.checkedAreas = [];
            this.clearFilters.wasteCollectionArea = "";           
            this.areasList = [];
            this.clearFilters.city = option;
            let cityId = option.value;
            this.parameters.cityId = cityId;
            if(this.$refs.wardReportTable.refresh){
                this.$refs.wardReportTable.refresh();
            }
            
            this.getWCAList(cityId);
        },
        onRemoveCityFilter(option) {
            this.count = 0;
            this.zoneFilterCount = 0;
            this.checkedAreas = [];           
            this.clearFilters.wasteCollectionArea = "";
            this.areasList = [];           
            let cityId = option.id;
            this.parameters.cityId = "";
            this.$refs.wardReportTable.refresh();
         
        },
        onCheckedFilter(option) {
            if(this.zoneFilterCount === 0){
                this.zoneFilterCount = 1;
                this.count +=1;
            }
            this.clearFilters.wasteCollectionArea = option;
            let id = option.wardId;
            this.checkedAreas.push(id);
            this.parameters.zone =  this.checkedAreas;
            this.$refs.wardReportTable.refresh();

        },
        onRemoveFilter(option) {
            let id = option.wardId;
            this.checkedAreas = this.checkedAreas.filter((elemant) => elemant != id);
            if(this.zoneFilterCount === 1 && this.checkedAreas.length === 0){
                this.count -=1;
                this.zoneFilterCount = 0;
            }
            this.parameters.zone =  this.checkedAreas;
            this.$refs.wardReportTable.refresh();
        },       

        gotoReportGeneration() {
            if (this.adminCheck == "superAdmin") {
                this.areas = [];
            }
            this.wardReport.cityId = "";
            this.wardReport.wardId = "";
            this.isGenerateReport = true;
            eventBus.$on('cityIdChanged', this.onChecked);
            if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
                this.isCityDisable = true
                this.wardReport.cityId = this.$store.state.auth.cityId.value
                this.getWCAList(this.$store.state.auth.cityId.value);
            }
        },
        onChecked(option){
            this.wardReport.cityId = option.value
            this.getWCAList(option.value);
        },
        onCheckedCity(id) {
            this.areas = [];
            // this.getWCAList(id);
        },
        onCheckedWard(value) {
            this.checkedWardValue = true;
        },

        getWCAList(id) {
            
            let data = [];
            return surveysService
                .getWasteCollectionAreaList(id)
                .then((response) => {
                    response.data.response.forEach((el) => {
                        let val = {};
                        val["wardName"] = el.areaName;
                        val["wardId"] = el._id;
                        data.push(val);
                    });
                    this.areas = data.sort((a, b) =>
                        a.wardName.localeCompare(b.wardName)
                    );
                    this.areasList = this.areas;
                   
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },

        generateReport() {
            this.reportLoading = true;
            let reportData = {};
            reportData["type"] = "html";
            reportData["wardId"] = this.wardReport.wardId;
            reportData["date"] = moment(String(this.wardReport.date)).format(
                "YYYY-MM-DD"
            );
            return reportsService
                .getWardReport(reportData)
                .then((response) => {
                    this.reportLoading = false;
                    if (!response.data.error) {
                        const renderedHTML = response.data;
                        // Open the rendered HTML in a new tab
                        const newTab = window.open("", "_blank");
                        // newTab.document.open();
                        if (newTab) {
                            newTab.document.write(renderedHTML);
                            newTab.document.close();
                        }
                        // this.isGenerateReport = false;
                        this.$refs.wardReportTable.refresh();
                    } else {
                        // this.isGenerateReport = false;
                        this.$snotify.error(response.data.error, "Error!");
                    }
                    this.wardReport.cityId = "";
                    this.wardReport.wardId = "";
                    this.wardReport.date = "";
                    this.isGenerateReport = false;
                })
                .catch((error) => {
                    this.$snotify.error(error.data.message, "Error!");
                    this.reportLoading = false;
                    this.wardReport.cityId = "";
                    this.wardReport.wardId = "";
                    this.wardReport.date = "";
                });
        },
        onModalClose() {
            this.wardReport.cityId = "";
            this.wardReport.wardId = "";
            this.wardReport.date = "";
            // this.$refs.reports.reset();
            this.isGenerateReport = false;
        },

        // clearStatus() {
        //   delete this.parameters["status"];
        //   this.statusValue = "";
        //   this.$refs.wardReportTable.refresh();
        // },
        UpdateDestination(row) {
            if (row.status == "ongoing") {
                this.$router.push({
                    name: "UpdateDestination",
                    params: {
                        _id: row._id,
                    },
                    props: row,
                });
            }
        },
        action(row) {
            this.$router.replace({
                name: "viewPrimaryTrip",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onLoaded() {
            this.wardReportTable = this.$refs.wardReportTable;
        },
        refreshReportList() {
            this.$refs.wardReportTable.refresh();
            this.loading = true;
        },

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin" || this.$store.state.auth.user.role.key === "subCityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName,
                }, ];
                this.isCityDisable = true;
                return;
            }
            // this.loading = true;
            const params = {};
            let cityList = [];
            // params.page = 1;
            // params.limit = 999;
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                    this.cityList = cityList
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },
    },
    mounted() {
        eventBus.$on('cityIdChanged', this.onCheckedCityFilter);
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
            this.getCityList();
        }
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onCheckedCityFilter);
    },
    created() {
        if(this.adminCheck !== "cityAdmin" || this.adminCheck !== "subCityAdmin"){
            this.parameters.cityId = this.$store.state.auth.cityId.value
            this.getWCAList(this.parameters.cityId);
        }
        this.adminCheck = this.$store.state.auth.user.role.key;
        let cityIdWCAList =
            this.$store.state.auth.user.cityId &&
            this.$store.state.auth.user.cityId._id ?
            this.$store.state.auth.user.cityId._id :
            "";
        if (this.adminCheck !== "superAdmin") {
            this.getWCAList(cityIdWCAList);
        }
    },
};
</script>

<style scoped>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 225px;
    margin-left: 250px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
    background-color: rgba(255, 132, 78);
    color: white;
}

.addnew {
    background-image: linear-gradient(to right,
            rgba(38, 153, 251),
            rgba(146, 205, 255));
    color: white;
}

.main_select_wrp_relative .modal-dialog {
    width: 50% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #0f6940;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}

.select_date_wrp .datedrop_boxs {
    position: static;
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: transparent;
}

.select_date_wrp {
    margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
    float: initial;
    background: transparent;
    margin-right: 0;
}

/* .dates_left label {
    color: #000;
} */

.dates_left {
    flex: 0 0 32.5%;
    margin-right: 10px;
}

.clearButton {
    margin-right: 33px;
    opacity: 0.8;
    color: blue;
    text-decoration: underline;
    font-size: large;
}

.filter-wrap .multiselected {
    min-width: 50%;
}

.form-modal-report {
    background: #fff;
}
.scroll_pop {
    padding-top: 15px;
    height: 327px;
    overflow: auto;

}
.scroll_pop::-webkit-scrollbar {
  width: 5px;
}
.scroll_pop::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.scroll_pop::-webkit-scrollbar-thumb {
  background: #888; 
}
.report .generate_report_pop .form-modal-report {
    width: 40%;
    padding: 24px 15px;
}

.mx-datepicker-popup {
    top: 37px !important;
}

@media (max-width: 767px) {
    .report .generate_report_pop .form-modal-report {
        width: 90%;
        padding: 15px;
    }
    .city_collection_reports_pop .modal-dialog{
        width: 94% !important;
    }
    .main_select_wrp_houses .multiselected {
    min-width: 100%;
}
}

.filter{
    margin-right: 5px;
}
.report_generation_progress a{
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// ward_collection_reports.vue?ed00e2e2